// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardGetForMemberBody = {
  poolId: string;
  targetUserId: string;
};

export type typeAwardGetForMemberOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    thisSeason: {
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    };
    allTime: {
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    };
    customAwardHistory: {
      awardGrantId: string;
      awardTypeId: string;
      name: string;
      color: string;
      kind: "medal" | "trophy";
      givenAt: string;
    }[];
  };
};

export type typeAwardGetForMemberOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardGetForMemberOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardGetForMemberOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardGetForMemberBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardGetForMember(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardGetForMemberBody);
  }

  return async function postAwardGetForMember(
    payload: typeAwardGetForMemberBody,
  ): Promise<typeAwardGetForMemberOutput200 | typeAwardGetForMemberOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardGetForMember" failed before calling the network. #fbb5c338d731`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#fbb5c338d731" },
        },
        data: null,
      } as typeAwardGetForMemberOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/get-for-member`,
      httpMethod: "POST",
      options,
    })) as typeAwardGetForMemberOutput200 | typeAwardGetForMemberOutput400;
  };
}
